/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { classifyTier } from "@cosmos/airtable-data";

import type { DirectoryCardBadge } from "@cosmos/components";

/** Subset of the `@epic-mw/i18n` messages dictionary the adapter consumes. */
type MessagesDict = Record<string, string>;

/**
 * Map an instructor's Airtable badge level to its card badge.
 *
 * The producer (s3-sync-service) only bakes Gold, Silver and Bronze
 * instructors. Anything else gets a neutral "Authorized instructor" badge
 * rather than claiming a tier the row doesn't carry. The Gold label keeps
 * the original `instructor.badge` key so its existing translations still apply.
 */
export function instructorBadge(badgeLevel: string, messages: MessagesDict): DirectoryCardBadge {
	switch (classifyTier(badgeLevel)) {
		case "gold":
			return { label: messages["epic.cosmos.directory.card.instructor.badge"] ?? "Gold instructor", tone: "gold" };
		case "silver":
			return {
				label: messages["epic.cosmos.directory.card.instructor.silver"] ?? "Silver instructor",
				tone: "silver",
			};
		case "bronze":
			return {
				label: messages["epic.cosmos.directory.card.instructor.bronze"] ?? "Bronze instructor",
				tone: "bronze",
			};
		default:
			return {
				label: messages["epic.cosmos.directory.card.instructor.authorized"] ?? "Authorized instructor",
				tone: "neutral",
			};
	}
}
